<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.OPTIONS.SELECTED"
    :handler="
      async () => {
        await $nextTick();
        await $nextTick();
        await $nextTick();
        $stores.services?.state?.transactionInitiation?.service?.id == 'usdt' &&
          $stores.services?.state?.transactionInitiation?.operation?.id ==
            'buy' &&
          $refs.modal.show();
      }
    "
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    hideCloseButton
    @closed="
      ({ source }) =>
        source !== 'external' &&
        $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
    "
  >
    <div class="p-6 flex flex-col gap-6">
      <form class="w-full grid grid-cols-12 gap-4" v-bus:EVENTS.SERVICES.INITIATION.SUBMIT_FORM.submit.prevent>
        <!-- amount -->
        <div class="col-span-12">
          <div class="relative">
            <input
              v-model="
                $stores.services.state.transactionInitiation
                  .recipientAmountOriginalCurrency
              "
              type="number"
              required
              placeholder=" "
              :id="'amount-' + $id"
              class="peer inputComponent pr-20"
              max="9999999999999"
              @input="validateBuyUsdtAmount"
            />
            <label
              :for="'amount-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Montant USDT (minimum: {{ minBuyUsdt }})
            </label>
            <div class="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">USDT</div>
            <div v-if="buyUsdtError" class="text-red-500 text-xs mt-1 pl-4">
              {{ buyUsdtError }}
            </div>
          </div>
        </div>

        <!-- conversion info -->
        <div class="col-span-12 bg-gray-50 rounded-xl p-4 text-center">
          <div class="text-sm text-gray-600">
            <span class="font-semibold text-gray-900">{{
              $stores.services.state.transactionInitiation
                .recipientAmountOriginalCurrency || 0
            }}</span> USD =
            <span class="font-semibold text-gray-900">{{
              $stores.services.state.transactionInitiation.recipientAmount || 0
            }}</span> FCFA
          </div>
        </div>

        <!-- phone -->
        <div class="col-span-12 mt-2">
          <div class="relative">
            <input
              v-model="$stores.services.state.transactionInitiation.phoneNumber"
              required
              type="text"
              inputmode="numeric"
              pattern="[0-9]{8,}"
              :placeholder="`Ex: ${getPhoneExample($stores.user.state.current?.countryCode)}`"
              :id="'phone-' + $id"
              class="peer inputComponent pr-24"
              ref="phoneNumberInput"
              @input="
                if (!$stores.services.state.transactionInitiation.phoneNumber) {
                  $refs.phoneNumberInput.setCustomValidity('');
                }
              "
            />
            <label
              :for="'phone-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Numéro Mobile Money
            </label>
            <div class="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2">
              <PhoneDetail
                :phoneNumber="
                  $stores.services.state.transactionInitiation.phoneNumber
                "
                :countryCode="$stores.user.state.current?.countryCode"
                @loading="
                  (data) => {
                    $refs.phoneNumberInput.setCustomValidity('chargement');
                    $stores.services.state.transactionInitiation.phoneOperator =
                      '';
                  }
                "
                @resolved="
                  (data) => {
                    $refs.phoneNumberInput.setCustomValidity('');
                    $stores.services.state.transactionInitiation.phoneOperator =
                      data.carrier;
                  }
                "
                @error="
                  (data) => {
                    $stores.services.state.transactionInitiation.phoneOperator =
                      '';
                    $refs.phoneNumberInput.setCustomValidity(
                      `Erreur du numéro: ${data.error}`
                    );
                  }
                "
                v-slot="{ carrier, logoUrl }"
              >
                <img v-if="logoUrl" :src="logoUrl" class="w-8 h-5 object-contain" alt="" />
                <span v-else class="text-xs text-gray-500">{{ carrier }}</span>
              </PhoneDetail>
            </div>
          </div>
        </div>

        <!-- usdt address type -->
        <div class="col-span-12">
          <div class="relative">
            <select
              :id="'addressType-' + $id"
              class="peer inputComponent appearance-none cursor-pointer"
              v-model="
                $stores.services.state.transactionInitiation.usdtAddressType
              "
              required
            >
              <option
                v-for="(option, i) in $constants.SERVICES.USDT_ADDRESS_TYPES"
                :value="option"
                :key="i"
              >
                {{ option.name }}
              </option>
            </select>
            <label
              :for="'addressType-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Type d'adresse USDT
            </label>
            <div class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- usdt account -->
        <div class="col-span-12">
          <div class="relative">
            <input
              v-model="
                $stores.services.state.transactionInitiation.usdtAccountId
              "
              type="text"
              required
              placeholder=" "
              :id="'usdtAccount-' + $id"
              class="peer inputComponent"
            />
            <label
              :for="'usdtAccount-' + $id"
              class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
            >
              Votre adresse USDT ({{ $stores.services.state.transactionInitiation?.usdtAddressType?.addressName || '' }})
            </label>
          </div>
        </div>

        <!-- video link -->
        <div class="col-span-12" v-if="tutorialVideoUrl">
          <div
            class="text-sm font-bold text-red-500 flex items-center justify-end gap-2 cursor-pointer"
            @click="$bus.emit($constants.EVENTS.VIDEO.PLAY, tutorialVideoUrl)"
          >
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
              />
            </svg>
            Voir comment faire un achat
          </div>
        </div>

        <!-- summary -->
        <div class="col-span-12">
          <ShortSummary />
        </div>

        <!-- submit button -->
        <div class="col-span-12">
          <button
            :disabled="
              $stores.services?.state?.transactionInitiationFees?.loadingFees ||
              $stores.services?.state?.initiatingPayment
            "
            :class="{
              'opacity-50':
                $stores.services?.state?.transactionInitiationFees
                  ?.loadingFees || $stores.services?.state?.initiatingPayment
            }"
            class="w-full py-4 bg-primary text-white rounded-xl font-semibold text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2"
            type="submit"
          >
            <span
              v-if="
                !$stores.services?.state?.transactionInitiationFees
                  ?.loadingFees && !$stores.services?.state?.initiatingPayment
              "
            >
              Acheter
              {{
                $stores.services?.state?.transactionInitiation
                  .recipientAmountOriginalCurrency || 0
              }}
              USDT
            </span>
            <span v-else class="flex items-center gap-2">
              <svg
                class="animate-spin"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="3"
                  class="opacity-25"
                />
                <path
                  fill="currentColor"
                  class="opacity-75"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Traitement...
            </span>
            <svg
              v-if="
                !$stores.services?.state?.transactionInitiationFees
                  ?.loadingFees && !$stores.services?.state?.initiatingPayment
              "
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M5 12h14M9 8l4 4-4 4" />
            </svg>
          </button>

          <button
            v-if="$stores.services?.state?.initiatingPayment"
            type="button"
            @click="
              $bus.emit($constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION)
            "
            class="w-full py-3 mt-2 text-red-600 font-bold border-2 border-red-100 rounded-xl hover:bg-red-50 transition-colors flex items-center justify-center gap-2"
          >
            Annuler la transaction
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { ref, computed } from 'vue';
import { getMinAmount, getEffectiveMaxLimit } from '@features/appData/limitsHelper';
import { resolveVideoLink } from '@features/appData/appDataHelper';
import { getPhoneExample } from '@features/shared/countries';

const { proxy } = getCurrentInstance();

const { $stores, $id } = proxy;

const buyUsdtError = ref(null);

const minBuyUsdt = computed(() => {
  const countryCode = $stores.user.state.current?.countryCode;
  if (!countryCode) return 0;
  return getMinAmount(countryCode, 'buy', 'usdt');
});

const maxBuyUsdt = computed(() => {
  const countryCode = $stores.user.state.current?.countryCode;
  if (!countryCode) return Infinity;
  return getEffectiveMaxLimit(countryCode, 'buy', 'usdt');
});

const tutorialVideoUrl = computed(() =>
  resolveVideoLink($stores.appData?.state?.data, {
    serviceId: $stores.services?.state?.transactionInitiation?.service?.id,
    operation: $stores.services?.state?.transactionInitiation?.operation?.id,
    countryCode: $stores.user.state.current?.countryCode
  })
);

function validateBuyUsdtAmount() {
  const amount = parseFloat(
    $stores.services.state.transactionInitiation
      .recipientAmountOriginalCurrency
  );
  const min = minBuyUsdt.value;
  const max = maxBuyUsdt.value;

  if (!amount || amount < min) {
    buyUsdtError.value = `Le montant minimum d'achat est de ${min} USDT`;
  } else if (max !== Infinity && amount > max) {
    buyUsdtError.value = `Le montant maximum d'achat est de ${max} USDT`;
  } else {
    buyUsdtError.value = null;
  }
}

validateBuyUsdtAmount();
</script>
